import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import './App.pcss';
import React from 'react';
import { createFilters } from './components';
const App = () => {
    React.useEffect(() => {
        window.addEventListener('custom:all-games-store:init', (e) => {
            const { element, state } = e.detail;
            element.classList.add('all-games');
            createFilters(state.storeState.units.items, element, state);
        });
    }, []);
    return _jsx(_Fragment, {});
};
export default App;
